/// <reference path="hero.HeroMediaBase.js" />
/*
 * PDP hero wrapper for composite/mashup images
 */
var CompositeImageHero = (function ($) {
    var CompositeImageInfo = (function () {
        var Rectangle = (function () {
            //component image size is 750, but adjusted for 5px padding on all sides
            var componentImageSize = 740;

            var rectangle = function (dx, dy) {
                var that = this;
                that.dx = dx;
                that.dy = dy;
                that.height = componentImageSize;
                that.width = componentImageSize;
            };

            return rectangle;
        })();

        var sourceImageSize = 1500,
            padding = 5,
            componentLayouts = {
                1: [new Rectangle(padding, padding)],
                2: [new Rectangle(sourceImageSize / 4 + padding, padding), new Rectangle(sourceImageSize / 4 + padding, sourceImageSize / 2 + padding)],
                3: [new Rectangle(padding, padding), new Rectangle(sourceImageSize / 2 + padding, padding), new Rectangle(sourceImageSize / 4 + padding, sourceImageSize / 2 + padding)],
                4: [new Rectangle(padding, padding), new Rectangle(sourceImageSize / 2 + padding, padding), new Rectangle(padding, sourceImageSize / 2 + padding), new Rectangle(sourceImageSize / 2 + padding, sourceImageSize / 2 + padding)]
            },
            workspaceCanvas = document.createElement('canvas'),
            workspaceContext = workspaceCanvas.getContext('2d');
        workspaceCanvas.height = workspaceCanvas.width = sourceImageSize;

        var compositeImageInfo = function () {
            var that = this;

            that.canvas = document.createElement('canvas'),
                that.ctx = that.canvas.getContext('2d');
        };

        function resizeCanvas(canvas, ctx, targetSize) {
            /// <summary>
            /// Helper method to resize the canvas to the given size using a "step down" method to help maintain image quality
            /// </summary>
            /// <param name="canvas" type="HTMLCanvasElement">Html canvas element to resize</param>
            /// <param name="ctx" type="CanvasRenderingContext2D">Canvas rendering context to draw</param>
            /// <param name="targetSize" type="Number">Target height/width of the canvas to scale down to</param>

            //don't resize by more than 50% to help maintain image quality
            //See https://stackoverflow.com/questions/17861447/ for more information
            var newSize = Math.max(targetSize, canvas.height * .5);
            workspaceContext.fillStyle = "#FFFFFF";
            workspaceContext.fillRect(0, 0, workspaceCanvas.width, workspaceCanvas.height);
            workspaceContext.drawImage(canvas, 0, 0, newSize, newSize);

            canvas.height = canvas.width = newSize;
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(workspaceCanvas, 0, 0, newSize, newSize, 0, 0, newSize, newSize);

            //if we didn't actually resize to the target size, then recursively apply the method until we do
            if (newSize !== targetSize) {
                resizeCanvas(canvas, ctx, targetSize);
            }
        }

        compositeImageInfo.prototype.updateImageInfo = function () {
            /// <summary>
            /// Updates the mashup image info object to contain the currently selected composite image urls
            /// </summary>
            var that = this,
                componentImages = [];

            $.each(imageMatrixLookup, function (matrixRow, matrixOptionId) {
                if (!matrixOptionId) {
                    return;
                }
                var img = imagesByMatrixOptionId[matrixOptionId];
                if (img) {
                    componentImages.push(img);
                }
            });

            componentImages = componentImages.slice(0, 4);
            var layout = componentLayouts[componentImages.length];

            if (!layout) {
                that.AlternateImageUrl = '//images.evo.com/imgp/80/_notavailable.jpg';
                that.EnlargeImageUrl = '//images.evo.com/imgp/enlarge/_notavailable.jpg';
                that.HeroImageUrl = '//images.evo.com/imgp/700/_notavailable.jpg';
                that.ZoomImageUrl = '//images.evo.com/imgp/zoom/_notavailable.jpg';
                return;
            }

            //reset the canvas
            that.canvas.height =
                that.canvas.width = sourceImageSize;

            //draw them to the canvas in the appropriate position
            for (var i = 0; i < layout.length && i < componentImages.length; i++) {
                var rect = layout[i];
                that.ctx.drawImage(componentImages[i], rect.dx, rect.dy, rect.height, rect.width);
            }

            that.ZoomImageUrl = that.canvas.toDataURL();
            resizeCanvas(that.canvas, that.ctx, 900);
            that.EnlargeImageUrl = that.canvas.toDataURL();
            resizeCanvas(that.canvas, that.ctx, 700);
            that.HeroImageUrl = that.canvas.toDataURL();
            resizeCanvas(that.canvas, that.ctx, 80);
            that.AlternateImageUrl = that.canvas.toDataURL();
        };

        return compositeImageInfo;
    })();

    var compositeImageHero = function ($container, $mediaElement) {
        /// <summary>
        /// Constructor for HeroMediaBase objects
        /// </summary>
        /// <param name="$container" type="JQueryObject">The jquery wrapper of the hero image container div</param>
        /// <param name="$mediaElement" type="JQueryObject">The jquery wrapper of the hero image/iframe element</param>
        var that = this;

        that.imageInfo = new CompositeImageInfo();
        that.imageInfo.updateImageInfo();

        imagesByProductImageId[-1] = that.imageInfo;
        $mediaElement.data('imageid', -1);

        ProductImageHero.call(that, $container, $mediaElement);

        evo.$.body.on('loaded.evo.pdp.interstitial', function (e, modal) {
            if (modal) {
                $(modal).find('.pdp-interstitial-thumb').attr('src', that.imageInfo.HeroImageUrl);
            }
        });
    };

    compositeImageHero.prototype = Object.create(ProductImageHero.prototype);
    compositeImageHero.prototype.constructor = compositeImageHero;

    compositeImageHero.prototype.updateImage = function () {
        var that = this;
        that.imageInfo.updateImageInfo();
        that.$alternateImage.children('img').attr('src', that.imageInfo.AlternateImageUrl);
        that.$mediaElement.attr('src', that.imageInfo.HeroImageUrl);

        if (that.$mediaElement.hasClass('active')) {
            ProductImageHero.prototype.select.call(that);
        }
    };

    return compositeImageHero;
}(jQuery));